const userMessage = (entry, pathname) => ({
  uid: entry.uid,
  role: 'user',
  content: entry.content,
  attachments: [],
  references: [],
  skills: [],
  parts: [],
  state: null,
  before: null,
  meta: null,
  pathname,
  status: 'done',
  restored: true,
});

const assistantMessage = (entry, pathname) => ({
  uid: `restored-${entry.uid}`,
  role: 'assistant',
  parts: [],
  state: null,
  before: null,
  meta: null,
  pathname,
  status: 'done',
  restored: true,
});

/**
 * The backend records one assistant message per model iteration, while the
 * live UI presents one assistant entry per user turn. Rebuild that same
 * turn shape without restoring historical undo snapshots onto the page.
 */
export const hydrateConversationMessages = (entries, pathname) => {
  const messages = [];
  let currentAssistant = null;
  let segment = 0;

  entries.forEach((entry) => {
    if (entry.role === 'user') {
      messages.push(userMessage(entry, pathname));
      currentAssistant = null;
      segment = 0;
      return;
    }
    if (entry.role !== 'assistant') return;

    if (!currentAssistant) {
      currentAssistant = assistantMessage(entry, pathname);
      messages.push(currentAssistant);
    }
    if (entry.content) {
      currentAssistant.parts.push({
        kind: 'text',
        text: entry.content,
        segment,
      });
      segment += 1;
    }
    (entry.tool_calls || []).forEach((toolCall) => {
      currentAssistant.parts.push({
        kind: 'tool',
        toolCall: {
          name: toolCall.name,
          description: toolCall.description,
          blocked: !!toolCall.blocked,
          failed: !!toolCall.failed,
          blockId: toolCall.block_id || null,
          before: toolCall.before ?? null,
          after: toolCall.after ?? null,
          image: toolCall.image || null,
          applied: false,
        },
      });
    });
    currentAssistant.state = entry.state || currentAssistant.state;
  });

  return messages;
};

export const titleFromMessages = (messages) => {
  const text = messages.find((message) => message.role === 'user')?.content;
  if (!text) return null;
  const normalized = text.replace(/\s+/g, ' ').trim();
  return normalized.length > 60
    ? `${normalized.slice(0, 57).trimEnd()}…`
    : normalized;
};
